import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SuccessfulPage } from './successful';

@NgModule({
  declarations: [
    SuccessfulPage,
  ],
  imports: [
    IonicPageModule.forChild(SuccessfulPage),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SuccessfulPageModule {}



// WEBPACK FOOTER //
// ./src/pages/successful/successful.module.ts